import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=432fdd5f&scoped=true&lang=pug"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=432fdd5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432fdd5f",
  null
  
)

export default component.exports